import React from 'react';
import Heading from '../../../Heading';
import Text from '../../../Text';
import Divider from '../../../Divider';
import { st, classes } from './Section.st.css';
import { dataHooks } from './constants';
import { SectionProps } from './Section.types';

const Section = ({
  dataHook,
  showDivider,
  title,
  subtitle,
  actionsBar,
  className,
}: SectionProps) => (
  <div
    className={st(classes.root, { showDivider }, className)}
    data-hook={dataHook}
  >
    <div className={classes.content}>
      <div className={classes.titleColumn}>
        {title && (
          <Heading
            size="small"
            as="h2"
            dataHook={dataHooks.pageSectionTitle}
            ellipsis
          >
            {title}
          </Heading>
        )}
        {subtitle && (
          <Text
            secondary
            weight="thin"
            ellipsis
            dataHook={dataHooks.pageSectionSubtitle}
          >
            {subtitle}
          </Text>
        )}
      </div>
      {actionsBar && (
        <div
          className={classes.actionsBar}
          data-hook={dataHooks.pageSectionActionsBar}
        >
          {actionsBar}
        </div>
      )}
    </div>
    {showDivider && <Divider className={classes.divider} />}
  </div>
);

Section.displayName = 'Page.Section';
export default Section;
